import { addEndScreenEvent } from '../helpers/tracking';
export default function modal(state = {}, action) {
    switch (action.type) {
        case 'SET_MODAL':
            if (action.modalType === 'SharingControl')
                addEndScreenEvent();
            return {
                modalType: action.modalType,
                content: action.content,
            };
        case 'CLEAR_MODAL':
            return {};
        default:
            return state;
    }
}
